import Color from '../../Color/Color'
import OverflowTooltip from '../OverflowTooltip/OverflowTooltip'
import Paragraph from '../../Paragraph/Paragraph'
import Tooltip from '../../Tooltip/Tooltip'
import classes from '../ComponentOverflow.module.scss'
import type { ReactNode } from 'react'

export interface Props {
  children: ReactNode[]
  placeholderHeader?: ReactNode
  gap: number
}

const OverflowPlaceholder = ({
  children,
  placeholderHeader,
  gap
}: Props) =>
  <div className={classes.OverflowPlaceholder}>
    <Tooltip
      backgroundVariance='white'
      label={
        <OverflowTooltip
          gap={gap}
          placeholderHeader={placeholderHeader}
        >
          {children}
        </OverflowTooltip>
      }
    >
      <Paragraph>
        <small>
          <Color variant='theme-description-text'>
            {
              children.length < 100
                ? `+${children.length}`
                : '+99'
            }
          </Color>
        </small>
      </Paragraph>
    </Tooltip>
  </div>

export default OverflowPlaceholder
